import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { remove } from 'lodash';

import { BizInfo, Sidebar, SidebarItem } from './types';


type SidebarState = Sidebar;

const initialState: SidebarState = {
    bizInfo: {
        companyId: '',
        companyName: '세원합동회계사무소zzzzzz',
        period: 1,
        startDate: new Date(),
        endDate: new Date(),
    },
    menuItems: [],
    menuOpen: true,
    expandedItem: null,
};

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        initializeSideBar: (
            state,
            action: PayloadAction<{ menuItems: SidebarItem[] }>
        ) => {
            return {
                ...state,
                menuItems: action.payload.menuItems,
                menuOpen: true,
            };
        },
        addMenuItem: (state, action: PayloadAction<SidebarItem>) => {
            state.menuItems.push(action.payload);
        },
        removeMenuItem: (state, action: PayloadAction<string>) => {
            remove(state.menuItems, (item) => item.title === action.payload);
        },
        toggleMenu: (state) => {
            state.menuOpen = !state.menuOpen;
        },
        setBizInfo: (state, action: PayloadAction<BizInfo>) => {
            state.bizInfo = action.payload;
        },
        setExpandedItem: (state, action: PayloadAction<string | null>) => {
            state.expandedItem = action.payload;
        },
        clickIcon: (state, action: PayloadAction<string>) => {
            state.expandedItem = action.payload;
        },
    },
});

export const {
    initializeSideBar,
    addMenuItem,
    removeMenuItem,
    toggleMenu,
    setBizInfo,
    setExpandedItem,
    clickIcon,
} = sidebarSlice.actions;